import React from 'react';
import { Box, BarChart2, ListOrdered } from 'lucide-react';
/**
 * Компонент секции параметров модели для 3D-печати
 */
const ModelParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <BarChart2 className="w-5 h-5 mr-2 text-teal-500" />
        Параметры модели
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Объем модели */}
        <div>
          <label htmlFor="modelVolume" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Объем модели (см³)
          </label>
          <input
            type="text"
            id="modelVolume"
            name="modelVolume"
            value={formData.modelVolume}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.modelVolume ? 'input-error' : ''}`}
            placeholder="Введите объем"
          />
          {errors.modelVolume && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.modelVolume}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Общий объем 3D-модели без учета поддержек
          </p>
        </div>

        {/* Вес модели */}
        <div>
          <label htmlFor="modelWeight" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Вес модели (г)
          </label>
          <input
            type="text"
            id="modelWeight"
            name="modelWeight"
            value={formData.modelWeight}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.modelWeight ? 'input-error' : ''}`}
            placeholder="Введите вес"
          />
          {errors.modelWeight && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.modelWeight}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Примерный вес готового изделия
          </p>
        </div>

        {/* Высота модели */}
        <div>
          <label htmlFor="modelHeight" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Высота модели (см)
          </label>
          <input
            type="text"
            id="modelHeight"
            name="modelHeight"
            value={formData.modelHeight}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.modelHeight ? 'input-error' : ''}`}
            placeholder="Введите высоту"
          />
          {errors.modelHeight && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.modelHeight}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Максимальная высота по оси Z (влияет на время печати)
          </p>
        </div>

        {/* Количество изделий */}
        <div>
          <label htmlFor="printQuantity" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <ListOrdered className="w-4 h-4 mr-1 text-teal-500" />
            Количество изделий
          </label>
          <input
            type="text"
            id="printQuantity"
            name="printQuantity"
            value={formData.printQuantity}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.printQuantity ? 'input-error' : ''}`}
            placeholder="Введите количество"
          />
          {errors.printQuantity && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.printQuantity}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Количество изделий в тираже
          </p>
        </div>
      </div>
      
      <div className="mt-4 bg-gray-50 dark:bg-gray-800/50 p-3 rounded-lg border border-gray-200 dark:border-gray-700">
        <div className="flex items-start">
          <Box className="w-5 h-5 text-teal-600 dark:text-teal-400 mr-3 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Подсказка по параметрам модели
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              Для получения точных данных об объеме и высоте модели используйте слайсер (например, Cura, PrusaSlicer, Chitubox) или программу 3D-моделирования. Если у вас есть STL-файл модели, вы можете узнать эти параметры перед слайсингом.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModelParametersSection;